<template>
  <main class="bg-white text-gray-800">
    <!-- About Section -->
    <section
      class="max-w-6xl mx-auto px-2 py-16 grid md:grid-cols-2 gap-4 items-center"
    >
      <div>
        <p class="text-sm md:text-base leading-relaxed mb-4">
          The Mshel Foundation is the philanthropic arm of Mshel Group,
          dedicated to giving back to the community through impactful
          initiatives.
        </p>
        <p class="text-sm md:text-base leading-relaxed">
          The foundation was born out of Dr. Barka Mshelia’s passion for helping
          the needy and empowering young entrepreneurs through mentorship and
          crucial financial support, enabling them to turn their innovative
          ideas into thriving businesses. The Mshel Foundation ensures a
          well-rounded approach to empowerment and the achievement of identified
          SDGs through initiatives like Mshel Pitch Your Dreams, Mshel
          Educational Programs, and Mshel Orphanage Visits.
        </p>

        <!-- Mission & Vision -->
        <div class="grid md:grid-cols-2 gap-4 mt-8">
          <div class="bg-white shadow-md rounded-xl py-4 px-2 text-center">
            <div
              class="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-indigo-100 text-indigo-600 rounded-full"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 4v16m8-8H4"
                />
              </svg>
            </div>
            <h3 class="font-semibold text-lg mb-2">Our Mission</h3>
            <p class="text-sm">
              To create meaningful and sustainable change in underserved
              communities and empower individuals to thrive and contribute to
              society.
            </p>
          </div>
          <div class="bg-white shadow-md rounded-xl py-4 px-2 text-center">
            <div
              class="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-indigo-100 text-indigo-600 rounded-full"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 4v16m8-8H4"
                />
              </svg>
            </div>
            <h3 class="font-semibold text-lg mb-2">Our Vision</h3>
            <p class="text-sm">
              To become a force in eradicating poverty and advancing quality
              education in underserved communities.
            </p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-2 grid-rows-2 gap-4 h-[500px]">
        <img
          src="../assets/images/group.png"
          alt="Home 1"
          class="rounded-2xl w-full h-full object-cover row-span-2"
        />
        <img
          src="../assets/images/hutu-exclusive.jpg"
          alt="Home 2"
          class="rounded-2xl w-full h-full object-cover"
        />
        <img
          src="../assets/images/kapital-villa.jpg"
          alt="Home 3"
          class="rounded-2xl w-full h-full object-cover"
        />
      </div>
    </section>

    <!-- Core Values -->
    <section class="bg-gray-100 py-16 text-center">
      <h2 class="text-2xl md:text-3xl font-semibold mb-10">Our Core Values</h2>
      <div class="flex flex-col md:flex-row justify-center gap-8 px-6">
        <div
          class="bg-gradient-to-r from-indigo-600 to-blue-600 text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">Empowerment</p>
        </div>
        <div
          class="bg-gradient-to-r from-orange-400 to-orange-300 text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">
            Compassion
          </p>
        </div>
        <div
          class="bg-gradient-to-r from-cyan-400 to-sky-400 text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">Integrity</p>
        </div>
        <div
          class="bg-gradient-to-r from-yellow to-yellow text-white p-6 rounded-full w-52 h-52 flex items-center justify-center flex-col shadow-lg mx-auto"
        >
          <p class="text-center text-sm font-medium">Sustainability</p>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {};
</script>

<style scoped></style>
